/* eslint-disable no-case-declarations */
import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SharedService } from 'libs/data/src/lib/services/shared/shared.service';
import {
  ExportProjectSummaryPayload,
  ReportsService,
} from 'libs/data/src/lib/services/report/reports.service';
import {
  ExportConnectionFailedError,
  ExportResult,
  ReportExportSignalrService,
  ReportHubMethod,
} from 'libs/data/src/lib/services/report/report-export-signalr.service';
import {
  NewReportFormatEnum,
  ReportFormatEnum,
  circleColors,
  commonEnum,
  loaderMessage,
  noReportConfigTxt,
  sensitivityLoaderMessage,
} from 'libs/shared/src/lib/constants';
import {
  FeatureValidation,
  addFullStop,
  customDecode,
  customEncode,
  encrypt,
  getReportGenerationBugId,
  isFeatureEnabled,
  showFeatureAlert,
  validateFeatures,
} from '@piqet-angular/data';
import { ToastrService } from 'ngx-toastr';
import { PDFExportComponent } from '@progress/kendo-angular-pdf-export';

import { InlineActionButtonComponent } from 'libs/ui/src/lib/inline-action-button/inline-action-button.component';
import { GridCellRendererComponent } from 'libs/ui/src/lib/grid-cell-renderer/grid-cell-renderer.component';
import { NewProjectInlineDropdownComponent } from 'libs/ui/src/lib/new-project-inline-dropdown/new-project-inline-dropdown.component';
import { ConfirmPayload, SwalService } from 'libs/shared/src/lib/service/swal.service';
import {
  AccessPermissionService,
  CustomModalService,
  superAdminRoleStr,
} from '@piqet-angular/shared';
import { CookieService } from 'ngx-cookie-service';
import { of, Subscription } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { EolNavigationService } from '../../../../../../../data/src/lib/services/shared/eol-navigation.service';
import { FeatureCodes } from '../../../../../../../shared/src/lib/constants';
import { JoyrideService } from 'ngx-joyride';
import { NgxSpinnerService } from 'ngx-spinner';
import { saveAs } from 'file-saver';
import { ViewportScroller, formatDate } from '@angular/common';

@Component({
  selector: 'piqet-angular-project-report-generation',
  templateUrl: './project-report-generation.component.html',
  styleUrls: ['./project-report-generation.component.scss'],
})
export class ProjectReportGenerationComponent implements OnInit, OnDestroy {
  PEF_CATEGORIES_WITH_TOXICITY = 17;
  PEF_CATEGORIES_WITHOUT_TOXICITY = 18;
  reportTypeList = ReportFormatEnum;
  FeatureCodes = FeatureCodes;
  noConfigTxt = noReportConfigTxt;
  // declare ids
  initialData: any;
  reportChartForm!: FormGroup;
  ISOReportForm: any;
  currentProjectId: any;
  selectedReportFormat: any;
  reportFormatData: any;

  // Dropdown list Declare
  includeScenarioList: any;
  functionalUnitList: any;
  baselineScenarioList: any;
  impactCategoriesList: any;
  includeCategoriesList: any;
  additionalInformationList: any;
  newFormateList: any;
  reportListByFormate: any;

  // Flags for Hide & Show
  isShowIncludeInputInformation = false;
  isShowSimpleDeck = false;
  isShowSlides = false;
  isShowCategoriesToInclude = true;
  isShowAdditionalInformationToInclude = false;
  isShowReportTitle = true;
  isDisabledSelectImpactCategories = false;

  // "Export project summary" Report Format option (NewReportFormatEnum.ExportProjectSummary).
  // The backend ships this in newReporFormatList; the frontend just adds
  // special UI handling: disable Report Type + Impact Category and show a
  // single "Export" button at the bottom.
  readonly NewReportFormatEnum = NewReportFormatEnum;
  isExportProjectSummary = false;
  isShowReportDetailsForExportSummary = false;
  // Guards against double-clicks and disables the Export button while exporting.
  isExporting = false;
  private exportSub?: Subscription;
  // Paced status ticker: keeps every step on screen for at least MIN_STEP_MS so
  // quick steps don't flash by, and animates trailing dots while waiting.
  private statusTimer: ReturnType<typeof setInterval> | null = null;
  private currentStatusBase = '';
  private pendingStatusBase: string | null = null;
  private currentStatusShownAt = 0;
  private statusDotPhase = 0;
  private readonly MIN_STEP_MS = 2800;
  private readonly STATUS_TICK_MS = 600;
  private readonly exportLoaderMessage = 'Preparing your export';
  // Array Used for make payload
  includeScenariosPayloadArray: any = [];
  includeCategoriesPayloadArray: any = [];
  additionalInformationPayloadArray: any = [];

  buttonName = `Generate`;
  alllReportData: any;
  selectFuntionalUnitData: any;
  selectBaselineScenarioListData: any;
  selectImpactCategoriesListData: any;
  selectAdditionalInformationListData: any;
  isCheckeportListByFormateById: any;
  isCheckeportListByTypeById: any;
  maxAllowedSelectedItems = 6;
  maxAllowedSelectedItemsForSlide!: number;
  chooseUpToMessage = '';
  chooseUpToMessageFOrOther = '';
  finalSubmit = false;
  isReportListByFormateDisabled = true;
  reportTypeIdByList: any;
  incorrectFilling: any = [];
  showIncorrectFillingNotification = false;
  newReportFormList: any;
  newReportTypeList: any;
  variationLists: any;
  commonEnum = commonEnum;
  isCheckeportListByTypeByFlag = false;
  reportData: any;
  @ViewChild('pdfData', { static: false }) pdfData!: PDFExportComponent;
  @ViewChild('pdfDataSecond', { static: false })
  pdfDataSecond!: PDFExportComponent;
  selectedReportTypeData: any;
  incorrectValueMessage =
    'Report results may be inaccurate due to outdated EOL rates in the project. Please update them before generating results.';
  incorrectBtnName = 'Show scenarios';
  isCheckISOReport = false;
  showEdit = false;
  isShowChange = false;
  selectedFileName: any;
  iserror = false;
  isImageValid = true;
  imageUrl: any;
  fileBase64: any;
  lcaString = 'LCA Report';
  sensitivityReportForm: any;
  @ViewChild('myFileInput', { static: false })
  myFileInput!: ElementRef<HTMLInputElement>;
  items: any[] = [];
  isHovered = false;
  ISOColumnDef: any;
  frameworkComponents = {
    inlineActionButtonComponent: InlineActionButtonComponent,
    GridCellRendererComponent: GridCellRendererComponent,
    newProjectInlineDropdownComponent: NewProjectInlineDropdownComponent,
  };
  reportFormatName = '';
  circleColors = circleColors;
  lstReasonForStudy: any = [];
  lstReviewer: any = [];
  systemBoundaryExamples: any = [{ id: 1, name: 'test' }];
  organizationDetails: any;
  dataQualityAssementTechnologyList: any[] = [];
  dataQualityAssessmnetList = [];
  disabledButton!: boolean;
  headerBtn!: string;
  originalImageSrc = './assets/icons/add-record.svg';
  hoverImageSrc = './assets/icons/add-record-hover.svg';
  disableImageSrc = './assets/icons/add-record-disable.svg';
  isCheckVariation!: boolean;
  errorIndex!: number;
  isReportGeneratable = true;
  userList: any;
  exportPayload: any;
  comingSoonText: any;
  dummyRecord: any;
  isEnableAllScenarioDrp = true;
  selectedBaseScenario: any;
  isShowScenarioNotification = false;
  lcaPresentenceText = 'lca presentation';
  EXPORT_RAW_DATA = 'export raw data';
  reportType: any;
  incorrectFillingValueMessage = 'Action needed: Please update the filling country.';
  incorrectFillingBtnName = 'Go to filling';
  showIncorrectEOLNotification = false;
  inValidScenarios: any = [];
  isSensitivityFeatureDisabled = false;
  functionalUnitText = '';
  private readonly ISO_REPORT_TEXT = 'ISO 14044 LCA Report';

  private readonly EXPORT_RAW_REPORT = 5;
  private readonly CUSTOM_CATEGORY = 7;
  hoveredIndex: number | null = null;
  tooltipMessage = '';
  decodeUserRole: any;
  constructor(
    private formBuilder: FormBuilder,
    private sharedService: SharedService,
    private route: Router,
    private reportService: ReportsService,
    private reportExportSignalr: ReportExportSignalrService,
    private toaster: ToastrService,
    private swalService: SwalService,
    private cookieService: CookieService,
    private modal: CustomModalService,
    private http: HttpClient,
    private accessService: AccessPermissionService,
    private eolNavService: EolNavigationService,
    public joyrideService: JoyrideService,
    private viewportScroller: ViewportScroller,
    private spinner: NgxSpinnerService
  ) {
    this.currentProjectId = Number(
      atob(decodeURIComponent(customDecode(location.href.split('/')[6])))
    );
    const userRole = this.cookieService.get('u_type');
    this.decodeUserRole = this.sharedService.decodeURIComponentParam(userRole)?.toLowerCase();
  }

  ngOnInit(): void {
    this.isCheckISOReport = false;
    this.showEdit = this.accessService.hasPermission('edit', '', 'packaging');
    this.isSensitivityFeatureDisabled = !isFeatureEnabled(
      FeatureCodes.REPORTS_SENSITIVITY_ANALYSIS
    );
    !this.joyrideService.isTourInProgress() && this.viewportScroller.scrollToPosition([0, 0]);
    this.formGroupRenderer();
    this.loadComingSoonText();
    this.asyncInitialFormData();
  }
  get formArray() {
    return (this.sensitivityReportForm.get('items') as FormArray).controls;
  }

  loadComingSoonText(): void {
    this.http.get<any[]>('../../../assets/json/report.json').subscribe(
      (data: any) => {
        this.dummyRecord = data?.dummyRecord;
        this.comingSoonText = data?.reportReleaseSoonText;
      },
      error => {}
    );
  }
  formGroupRenderer() {
    this.reportChartForm = this.formBuilder.group({
      // input
      reportTitle: [null],

      // checkbox
      excludeProductImpacts: [false, Validators.required],
      includeInputInformation: [false, Validators.required],

      // dropdowns
      // reportFormat: [null, Validators.required],
      newFormateList: [null, Validators.required],
      reportFormatByList: [null],
      includeScenario: [null, Validators.required],
      functionalUnit: [null, Validators.required],
      baselineScenario: [null, Validators.required],
      impactCategories: [null],
      includeCategories: [null],
      additionalInformation: [null],
      functionalUnitText: [''],
      ISOReportForm: this.formBuilder.group({
        reasonOfStudy: [null],
        criticalViewer: [null],
        organizationISO: [null],
        viewSysBoundry: [null],
        boundryJustification: [''],
        excludedProcessJusti: [''],
        impactCategoryJustification: [''],
        multiFunJustification: [''],
        otherAssumption: [''],
        conclusion: [''],
      }),
    });
    this.sensitivityReportForm = this.formBuilder.group({
      items: this.formBuilder.array([]),
    });
    this.ISOReportForm = this.reportChartForm.controls['ISOReportForm'];
    this.ISOReportForm.get('organizationISO').disable();
    this.addItem();
  }
  triggerScroll(): void {
    this.sharedService.triggerScroll();
  }

  async asyncInitialFormData() {
    const response = await this.reportService.getReportGenerationInitialData(this.currentProjectId);
    this.initialData = response;
    this.showIncorrectFillingNotification = response.data?.incorrectFillingDataList?.length > 0;
    this.incorrectFilling = response.data?.incorrectFillingDataList || [];
    this.incorrectFillingBtnName =
      this.incorrectFilling.length > 1 ? 'Show scenarios' : 'Go to filling';
    this.showIncorrectEOLNotification = response.data?.invalidEOLRates;
    this.inValidScenarios = response.data?.inValidScenarios;
    this.incorrectBtnName = this.inValidScenarios.length > 1 ? 'Show scenarios' : 'Go to scenario';
    if (this.initialData?.data?.organizationDetail) {
      this.organizationDetails = this.initialData?.data?.organizationDetail || [];
      this.ISOReportForm.patchValue({
        organizationISO: this.organizationDetails?.name,
      });
    }
    this.reportTypeList.map((item: any) => {
      if (item.id == this.initialData.data.reportFormatId) {
        return (this.reportFormatData = item);
      }
    });
    this.initialData.data.newReporFormatList.map((data: any) => {
      if (data.id == this.initialData.data.newReportFormatId) {
        this.isReportListByFormateDisabled = false;
        if (
          this.initialData.data.newReportFormatId == NewReportFormatEnum.ExportRawData ||
          this.initialData.data.newReportFormatId == NewReportFormatEnum.ExportRawDataNew
        ) {
          this.isReportListByFormateDisabled = true;
        }
        return (this.newReportFormList = data);
      }
    });
    this.isCheckeportListByTypeByFlag = this.initialData.data.isCustomType;
    this.initialData.data?.newReporTypeList?.map((data: any, index: number) => {
      data.childItems?.map((x: any) => {
        if (
          data.id == 1 &&
          !this.initialData.data.isCustomType &&
          this.initialData.data.reportFormatId != 13 &&
          x.id == this.initialData.data.newReportTypeId
        ) {
          x.selected = true;
          this.selectedReportTypeData = x;
          this.isReportGeneratable = x?.isReportGeneratable;
        } else if (
          data.id == 2 &&
          this.initialData.data.isCustomType &&
          x.id == this.initialData.data.newReportTypeId
        ) {
          x.selected = true;
          this.selectedReportTypeData = x;
          this.isReportGeneratable = x?.isReportGeneratable;
        } else if (
          data.id == 3 &&
          this.initialData.data.reportFormatId == 13 &&
          x.id == this.initialData.data.newReportTypeId
        ) {
          x.selected = true;
          this.selectedReportTypeData = x;
          this.isReportGeneratable = x?.isReportGeneratable;
        }
      });
    });
    this.selectedReportFormat =
      !!this.reportFormatData?.id || this.reportFormatData?.id === 0
        ? this.reportFormatData.id
        : this.initialData.data.reportFormatId || this.reportTypeList[0].id;
    this.reportTypeIdByList = this.selectedReportFormat;
    this.isCheckeportListByFormateById = this.initialData.data.newReportFormatId;
    this.reportType = this.initialData.data.newReportFormatId;
    // The backend's reportFormatId doesn't know about the newFormateList categories,
    // so when a report was previously saved as Export raw data (new) it still comes
    // back with the old reportFormatId. Re-derive reportTypeIdByList the same way
    // onChangeNewReportList does, or Generate dispatches to the wrong report type.
    if (this.isCheckeportListByFormateById == NewReportFormatEnum.ExportRawData) {
      this.reportTypeIdByList = 5;
    } else if (this.isCheckeportListByFormateById == NewReportFormatEnum.ExportRawDataNew) {
      this.reportTypeIdByList = 14;
    }
    if (!this.isCheckeportListByTypeByFlag) {
      this.reportChartForm.controls['impactCategories'].setValidators([Validators.required]);
    } else {
      this.reportChartForm.controls['impactCategories'].clearValidators();
    }
    this.reportChartForm.controls['impactCategories'].updateValueAndValidity();
    if (
      this.isCheckeportListByFormateById != NewReportFormatEnum.ExportRawData &&
      this.isCheckeportListByFormateById != NewReportFormatEnum.ExportRawDataNew
    ) {
      this.reportChartForm.controls['reportFormatByList'].setValidators([Validators.required]);
      this.reportChartForm.controls['reportTitle'].setValidators([Validators.required]);
    } else {
      this.reportChartForm.controls['reportFormatByList'].clearValidators();
      this.reportChartForm.controls['reportTitle'].clearValidators();
    }
    this.isCheckeportListByTypeById = this.initialData.data.newReportTypeId;
    this.isShowIncludeInputInformation =
      this.newReportFormList?.name == 'LCA Presentation' ? true : false;
    this.buttonName = this.newReportFormList?.name == 'Export raw data' ? 'Export' : `Generate `;
    this.reportChartForm.patchValue({ newFormateList: this.newReportFormList });
    this.reportFormatName = this.newReportFormList?.name;
    if (
      this.isCheckeportListByFormateById == 1 ||
      (this.isCheckeportListByFormateById == 2 && !this.dummyRecord?.disabled)
    ) {
      this.initialData.data.newReporTypeList?.length &&
        this.initialData.data.newReporTypeList[1]?.childItems?.length == 0 &&
        this.initialData.data.newReporTypeList[1]?.childItems.push(commonEnum.dummyRecord);
    }
    if (this.dummyRecord?.disabled && this.isCheckeportListByFormateById == 2) {
      const reportList = this.initialData.data.newReporTypeList?.find((x: any) => x.id == 2);
      if (reportList?.childItems.length >= 0) {
        reportList.childItems = [];
        reportList?.childItems.push(this.dummyRecord);
      }
    }

    if (this.initialData.data.newReporTypeList && this.isCheckeportListByFormateById == 1) {
      const standardReports = this.initialData.data.newReporTypeList.find((x: any) => x.id == 1);
      if (standardReports && standardReports.childItems) {
        const isoReport = standardReports.childItems.find(
          (item: any) => item.name === this.ISO_REPORT_TEXT
        );
        if (isoReport && !isFeatureEnabled(this.FeatureCodes.REPORTS_ISO_14044_LCA_REPORT)) {
          isoReport.disabled = true;
          isoReport.isFeatureDisabled = true;
        }
      }

      // Disable Custom report section if feature is disabled
      const customReportSection = this.initialData.data.newReporTypeList.find(
        (x: any) => x.id == 2
      );
      if (customReportSection && !isFeatureEnabled(this.FeatureCodes.REPORTS_CUSTOM_REPORT)) {
        customReportSection.disabled = true;
        customReportSection.isFeatureDisabled = true;
        // Optionally, disable all child items too
        if (customReportSection.childItems) {
          customReportSection.childItems.forEach((item: any) => {
            item.disabled = true;
            item.isFeatureDisabled = true;
          });
        }
      }
    }

    // Tag each child item with its parent category ID to prevent ID collisions
    this.initialData.data.newReporTypeList?.forEach((category: any) => {
      if (category.childItems) {
        category.childItems.forEach((item: any) => {
          item._categoryId = category.id;
        });
      }
    });
    this.reportListByFormate =
      this.initialData.data.newReporTypeList?.filter(
        (category: any) =>
          category.id !== 3 || (category.childItems && category.childItems.length > 0)
      ) || [];
    if (this.selectedReportTypeData?.name == this.ISO_REPORT_TEXT) {
      this.reportChartForm.controls['functionalUnitText']?.untouched;
      this.reportChartForm.controls['functionalUnitText'].setValidators(Validators.required);
    } else {
      this.reportChartForm.controls['functionalUnitText'].clearValidators();
    }
    this.reportChartForm.controls['functionalUnitText'].updateValueAndValidity();
    this.reportChartForm.patchValue({
      reportFormatByList:
        this.newReportFormList?.name == 'Export raw data' ? null : this.selectedReportTypeData,
    });
    this.reportChartForm.patchValue({
      reportTitle: this.initialData.data.projectName,
      functionalUnitText: this.initialData.data.functionalUnitText,
    });
    this.functionalUnitText = this.initialData.data.functionalUnitText;
    this.hideShowDropdowns(this.selectedReportFormat);
    // Ensure title visibility matches the report format category (Export raw data = 3/6 hides title)
    this.isShowReportTitle =
      this.isCheckeportListByFormateById != NewReportFormatEnum.ExportRawData &&
      this.isCheckeportListByFormateById != NewReportFormatEnum.ExportRawDataNew;
    this.getReportFormData(this.selectedReportFormat);
    if (this.initialData.data.reportFormatId == 11) {
      //ISO REPORT
      this.isCheckISOReport = true;
    }
  }

  selectAddRefrences(event: any, index: number) {
    if (event?.idStr) {
      const variaton = this.baselineScenarioList.filter((x: any) => x.idStr != event.idStr);
      this.variationLists = variaton;
      const itemsArray = this.sensitivityReportForm.get('items') as FormArray;
      const item = itemsArray.at(index) as FormGroup | null;

      // Set values only for the specified item
      if (item) {
        item.controls['variationOne'].setValue(null);
        item.controls['variationTwo'].setValue(null);
        item.controls['variationThree'].setValue(null);
        item.controls['variationFour'].setValue(null);
      }
    }
  }

  resetCalculations(index: number) {
    const itemsArray = this.sensitivityReportForm.get('items') as FormArray;
    const item = itemsArray.at(index) as FormGroup | null;
    // Set values only for the specified item
    if (item) {
      item.controls['variationOne'].setValue(null);
      item.controls['variationTwo'].setValue(null);
      item.controls['variationThree'].setValue(null);
      item.controls['variationFour'].setValue(null);
    }
  }
  onChangeNewReportList(event: any) {
    if (!event) return;

    // Handle the "Export project summary" option:
    // hides + disables Report Type, Impact Category, Report Title, Functional Unit,
    // Base Scenario, Functional Unit Text, and Categories to Include — and shows
    // only the Export button at the bottom.
    if (
      event.id === NewReportFormatEnum.ExportProjectSummaryQuadpack ||
      event.id === NewReportFormatEnum.ExportProjectSummaryAllOrganization
    ) {
      this.isExportProjectSummary = true;
      this.reportType = event.id;
      this.reportFormatName = event?.name;
      this.isCheckeportListByFormateById = event.id;
      this.isShowReportDetailsForExportSummary =
        event.id === NewReportFormatEnum.ExportProjectSummaryAllOrganization;
      // Form controls whose UI is hidden — clear value & validators so the
      // form stays valid, but DO NOT call disable(). Disabling baselineScenario
      // can cascade into the includeScenario click handler (which checks
      // baselineScenario.invalid) and re-locks the scenarios dropdown.
      const controlsToReset = [
        'reportFormatByList',
        'impactCategories',
        'includeCategories',
        'functionalUnit',
        'baselineScenario',
        'functionalUnitText',
        'reportTitle',
      ];
      for (const name of controlsToReset) {
        const ctrl = this.reportChartForm.controls[name];
        if (!ctrl) continue;
        ctrl.reset();
        ctrl.clearValidators();
        ctrl.updateValueAndValidity();
      }

      // Defensive: make sure the scenarios dropdown is enabled and editable.
      this.reportChartForm.controls['includeScenario']?.enable();
      this.isDisabledSelectImpactCategories = true;
      this.isReportListByFormateDisabled = true;
      this.isEnableAllScenarioDrp = false;
      this.isShowScenarioNotification = false;

      this.maxAllowedSelectedItems = this.includeScenarioList.length;
      this.maxAllowedSelectedItemsForSlide = this.includeCategoriesList.length;
      this.chooseUpToMessage = '';
      this.chooseUpToMessageFOrOther = '';

      return;
    }

    // User switched away from "Export project summary" — flip the flag.
    // The downstream getReportFormData call will re-establish validators
    // and values via the standard bindReportList flow.
    if (this.isExportProjectSummary) {
      this.isExportProjectSummary = false;
      // The export-summary branch locked Impact categories; re-enable it so
      // the dropdown is editable again for the newly selected report format.
      this.isDisabledSelectImpactCategories = false;
    }

    // export row data = 3
    this.reportType = event.id;
    this.reportFormatName = event?.name;
    this.isShowIncludeInputInformation = event?.name == 'LCA Presentation' ? true : false;

    if (this.isShowIncludeInputInformation) this.isReportGeneratable = true;
    this.buttonName = event?.name == 'Export raw data' ? 'Export' : `Generate `;
    if (event.name == 'Export raw data') {
      this.maxAllowedSelectedItems = this.includeScenarioList.length;
      this.maxAllowedSelectedItemsForSlide = this.includeCategoriesList.length;
      this.chooseUpToMessage = '';
      this.chooseUpToMessageFOrOther = '';
      this.getExcelSummeryReportData();
    } else {
      this.maxAllowedSelectedItems = 6;
      this.maxAllowedSelectedItemsForSlide = this.includeCategoriesList.length;
      this.chooseUpToMessage = 'Select up to 6 scenarios';
      this.chooseUpToMessageFOrOther = '';
      // full report == 3
      this.getReportFormData(3);
    }
    this.reportChartForm.patchValue({
      reportTitle: this.initialData.data.projectName,
    });
    if (event.id) {
      if (event.id == NewReportFormatEnum.ExportRawData) {
        this.reportTypeIdByList = 5;
        this.isShowReportTitle = false;
      } else if (event.id == NewReportFormatEnum.ExportRawDataNew) {
        this.reportTypeIdByList = 14;
        this.isShowReportTitle = false;
      } else {
        this.reportTypeIdByList = 0;
        this.isShowReportTitle = true;
        this.reportChartForm.patchValue({
          reportTitle: this.initialData.data.projectName,
        });
      }
    }
    this.reportChartForm.controls['reportFormatByList'].reset();
    if (event.id) {
      this.isCheckeportListByFormateById = event.id;
      this.isReportListByFormateDisabled =
        event.id == NewReportFormatEnum.ExportRawData ||
        event.id == NewReportFormatEnum.ExportRawDataNew;
      if (
        event.id != NewReportFormatEnum.ExportRawData &&
        event.id != NewReportFormatEnum.ExportRawDataNew
      ) {
        this.reportChartForm.controls['reportFormatByList'].setValidators([Validators.required]);
        this.reportChartForm.controls['reportTitle'].setValidators([Validators.required]);
      } else {
        this.reportChartForm.controls['reportFormatByList'].clearValidators();
        this.reportChartForm.controls['reportTitle'].clearValidators();
      }
      this.reportChartForm.controls['reportFormatByList'].updateValueAndValidity();
      this.reportChartForm.controls['reportTitle'].updateValueAndValidity();
      this.reportService.getReportTypeByReportFormat(event.id).subscribe((data: any) => {
        if (event.id == 1 || (event.id == 2 && !this.dummyRecord.disabled)) {
          data.data[1].childItems.length == 0 &&
            data.data[1].childItems.push(commonEnum.dummyRecord);
        }
        if (event.id == 2) {
          //LCA Presentation report
          if (this.dummyRecord.disabled) {
            const reportList = data.data.find((x: any) => x.id == 2); // for custom report
            if (reportList?.childItems.length >= 0) {
              reportList.childItems = [];
              reportList?.childItems.push(this.dummyRecord);
            }
          }
        }

        if (event.id == 1) {
          // LCA Report
          // Disable ISO 14044 LCA Report if feature is disabled
          const standardReports = data.data.find((x: any) => x.id == 1);
          if (standardReports && standardReports.childItems) {
            const isoReport = standardReports.childItems.find(
              (item: any) => item.name === this.ISO_REPORT_TEXT
            );
            if (isoReport && !isFeatureEnabled(this.FeatureCodes.REPORTS_ISO_14044_LCA_REPORT)) {
              isoReport.disabled = true;
              isoReport.isFeatureDisabled = true;
            }
          }

          // Disable Custom report section if feature is disabled
          const customReportSection = data.data.find((x: any) => x.id == 2);
          if (customReportSection && !isFeatureEnabled(this.FeatureCodes.REPORTS_CUSTOM_REPORT)) {
            customReportSection.disabled = true;
            customReportSection.isFeatureDisabled = true;
            // Optionally, disable all child items too
            if (customReportSection.childItems) {
              customReportSection.childItems.forEach((item: any) => {
                item.disabled = true;
                item.isFeatureDisabled = true;
              });
            }
          }
        }

        // Tag each child item with its parent category ID so we can
        // reliably determine which category a selected item belongs to
        // (prevents ID collisions between standard reports and report templates)
        data.data.forEach((category: any) => {
          if (category.childItems) {
            category.childItems.forEach((item: any) => {
              item._categoryId = category.id;
            });
          }
        });

        this.reportListByFormate = data.data.filter(
          (category: any) =>
            category.id !== 3 || (category.childItems && category.childItems.length > 0)
        );
      });
    }
  }

  async onChnageReportListByFormate(event: any) {
    if (event.id) {
      this.isCheckeportListByTypeById = event.id;
      this.isCheckeportListByTypeByFlag = event.flag;
      this.isReportGeneratable = event?.isReportGeneratable;
      if (!this.isReportGeneratable) this.toaster.warning(this.noConfigTxt);
      this.isCheckISOReport = event.name.toLowerCase() == this.ISO_REPORT_TEXT.toLowerCase();
      if (this.isCheckISOReport) {
        this.reportChartForm.controls['functionalUnitText']?.untouched;
        this.reportChartForm.controls['functionalUnitText'].setValidators(Validators.required);
      } else {
        this.reportChartForm.controls['functionalUnitText'].clearValidators();
      }
      this.reportChartForm.controls['functionalUnitText'].updateValueAndValidity();

      // Check if selected item is a Report Template (category 3)
      // Ensure impact categories dropdown is visible and selectable for report templates
      if (event._categoryId === 3) {
        this.isCheckeportListByTypeByFlag = false;
        this.reportChartForm.controls['impactCategories'].setValidators([Validators.required]);
        this.reportChartForm.controls['impactCategories'].updateValueAndValidity();
        this.reportTypeIdByList = 13;
        this.onChnageReportFormat(13);
        return;
      }

      if (!this.isCheckeportListByTypeByFlag) {
        this.reportChartForm.controls['impactCategories'].setValidators([Validators.required]);
      } else {
        this.reportChartForm.controls['impactCategories'].clearValidators();
      }
      this.reportChartForm.controls['impactCategories'].updateValueAndValidity();

      const data = await this.reportService.getReportGenrationTypeByTypeIdAndFormateId(
        this.isCheckeportListByFormateById,
        event.id,
        event.flag
      );
      if (event.flag) {
        const responseIncludeCatogaries =
          await this.reportService.GetCustomReportSettingIndicatorItems(event.id);
        this.reportChartForm.controls['includeCategories'].setValue(null);
        this.includeCategoriesList = responseIncludeCatogaries.data;
      }
      this.reportTypeIdByList = data.data;
      this.onChnageReportFormat(data.data);
    }
  }

  onChnageReportFormat(event: any) {
    this.selectImpactCategoriesListData = null;
    switch (event) {
      case 3:
      case 12: //PIQET Summary report
      case 4:
      case 6:
      case 8:
      case 11: //ISO REPORT
      case 0: //custom report
      case 13: // Report Template
        this.maxAllowedSelectedItems = 6;
        this.maxAllowedSelectedItemsForSlide = this.includeCategoriesList.length;
        this.chooseUpToMessage = 'Select up to 6 scenarios';
        this.chooseUpToMessageFOrOther = '';
        this.getReportFormData(event);
        break;
      case 5:
        this.maxAllowedSelectedItems = this.includeScenarioList.length;
        this.maxAllowedSelectedItemsForSlide = this.includeCategoriesList.length;
        this.chooseUpToMessage = '';
        this.chooseUpToMessageFOrOther = '';
        this.getExcelSummeryReportData();
        break;
      case 7:
      case 10:
        this.maxAllowedSelectedItems = 6;
        this.chooseUpToMessage = 'Choose up to 6 scenarios';
        this.chooseUpToMessageFOrOther = 'Choose up to 8 categories to include';
        this.maxAllowedSelectedItemsForSlide = 8;
        this.getSlideReportData(event);
        break;
    }
    this.hideShowDropdowns(event);
    // this.getMaterialDataForISOreport();
  }

  hideShowCategoriesToInclude(event: any) {
    // Check if the selected item is disabled
    if (event && event.disabled) {
      // Reset to null to prevent selection
      setTimeout(() => {
        this.reportChartForm.controls['impactCategories'].setValue(null);
      }, 0);
      return;
    }

    // 7 == customize categories
    if (event?.id) {
      this.reportChartForm.controls['includeCategories'].setValue(null);
      if (event.id === 7) {
        this.isShowCategoriesToInclude = true;
        this.reportChartForm.get('includeCategories')?.setValidators([Validators.required]);
      } else {
        this.isShowCategoriesToInclude = false;
        this.reportChartForm.get('includeCategories')?.clearValidators();
        this.reportChartForm.controls['includeCategories'].setValue(null);
      }
      this.reportChartForm.get('includeCategories')?.updateValueAndValidity();
    }
  }

  // Get and Set report data for Compact - Full - Product waste - Carbon footprint
  async getReportFormData(reportFormatId: any) {
    this.selectImpactCategoriesListData = null;
    switch (reportFormatId) {
      case 3:
      case 4:
      case 6:
      case 8:
      case 11:
      case 12:
      case 13:
      case 0:
        const id = this.isCheckeportListByTypeByFlag ? this.isCheckeportListByTypeById : 0;
        const reportGenerateTypeId = this.isCheckeportListByTypeByFlag ? 0 : reportFormatId;
        const response = await this.reportService.getReportGenerationData(
          this.currentProjectId,
          reportGenerateTypeId,
          id
        );
        this.alllReportData = response.data;
        this.bindReportList(response.data);
        this.pathchFormControls(response.data);
        break;
      case 5:
        this.getExcelSummeryReportData();
        break;
      case 7:
      case 10:
        this.getSlideReportData(reportFormatId);
        break;
      default:
        break;
    }
  }

  // Get and Set report data for Excel Summery
  getExcelSummeryReportData() {
    this.reportService
      .getReportGenerationDataForExcelSummery(this.currentProjectId)
      .subscribe((response: any) => {
        this.alllReportData = response.data;
        this.bindReportList(response.data);
        this.pathchFormControls(response.data);
      });
  }

  // Get and Set report data for Slide - Simple Slide Deck
  getSlideReportData(reportFormatId: any) {
    this.reportService
      .getReportGenerationDataForSlide(this.currentProjectId, reportFormatId)
      .subscribe((response: any) => {
        this.alllReportData = response.data;
        this.bindReportList(response.data);
        this.pathchFormControls(response.data);
      });
  }

  commonInputSearchName(term: string, item: any) {
    return item.name.toLowerCase().includes(term.toLowerCase());
  }
  commonInputSearchDisplay(term: string, item: any) {
    return item.display.toLowerCase().includes(term.toLowerCase());
  }
  commonInputSearchDes(term: string, item: any) {
    return item.description.toLowerCase().includes(term.toLowerCase());
  }

  excludeProductImpact(event: any) {
    this.reportService.GetChartCompareTypeProductWise(event.target.checked).subscribe(data => {});
  }

  addDisableOption(data: any) {
    const lcaPresentation = data.newReporFormatList?.find(
      (item: any) => item?.name?.toLowerCase() === this.lcaPresentenceText
    );

    if (lcaPresentation && this.comingSoonText) {
      lcaPresentation.disabled = this.comingSoonText.disable;
    }
  }
  // Bind Report Data To List
  bindReportList(data: any) {
    switch (data?.reportFormatId) {
      case 3:
      case 4:
      case 6:
      case 8:
      case 0:
      case 11:
      case 12:
      case 13:
        this.addDisableOption(data);
        this.newFormateList = data.newReporFormatList;
        this.chooseUpToMessage = 'Select up to 6 scenarios';
        this.chooseUpToMessageFOrOther = '';
        this.maxAllowedSelectedItems = 6;
        this.isShowCategoriesToInclude = data.impactCategoryId == 7 ? true : false; // 7 = customize catogories id
        this.includeScenarioList = data.fullReportProductPackageScenarioItems;
        this.functionalUnitList = data.functionalUnitItems;
        this.baselineScenarioList = data.productPackageScenarioItems.map((item: any) => {
          return {
            ...item,
            isShow: true,
          };
        });
        this.impactCategoriesList = data.impactCategoryItems;
        this.setupImpactCategories(this.impactCategoriesList);
        this.includeCategoriesList = data.indicatorItems;
        this.additionalInformationList = data.addtitionalCategoryItems;
        this.maxAllowedSelectedItemsForSlide = this.includeCategoriesList.length;
        this.lstReasonForStudy = data.isoReportDetailViewModel?.lstReasonForStudy;
        this.lstReviewer = data.isoReportDetailViewModel?.lstReviewer;
        // this.isoReportDetail = data.isoReportDetailViewModel;
        this.setupImpactCategories(this.impactCategoriesList);
        break;
      case 5:
        this.addDisableOption(data);
        this.newFormateList = data.newReporFormatList;
        this.maxAllowedSelectedItems = data.productPackageScenarioItems.length;
        this.isShowCategoriesToInclude = data.impactCategoryId == 7 ? true : false; // 7 = customize catogories id
        this.includeScenarioList = data.productPackageScenarioItems;
        this.functionalUnitList = data.functionalUnitItems;
        this.baselineScenarioList = data.baseScenarioItems;
        this.impactCategoriesList = data.impactCategoryItems;
        this.setupImpactCategories(this.impactCategoriesList);
        this.includeCategoriesList = data.indicatorItems;
        this.maxAllowedSelectedItemsForSlide = this.includeCategoriesList.length;
        this.chooseUpToMessage = '';
        this.chooseUpToMessageFOrOther = '';
        break;
      case 7:
      case 10:
        this.addDisableOption(data);
        this.newFormateList = data.newReporFormatList;
        this.chooseUpToMessage = 'Choose up to 6 scenarios';
        this.chooseUpToMessageFOrOther = 'Choose up to 8 categories to include';
        this.maxAllowedSelectedItems = 6;
        this.isShowCategoriesToInclude = data.impactCategoryId == 7 ? true : false; // 7 = customize catogories id
        this.includeScenarioList = data.fullReportProductPackageScenarioItems;
        this.functionalUnitList = data.functionalUnitItems;
        this.baselineScenarioList = data.baseScenarioItems;
        this.impactCategoriesList = data.impactCategoryItems;
        this.setupImpactCategories(this.impactCategoriesList);
        this.includeCategoriesList = data.indicatorItems;
        this.maxAllowedSelectedItemsForSlide = 8;
        break;
      default:
        this.includeScenarioList = data.productPackageScenarioItems;
        this.functionalUnitList = data.functionalUnitItems;
        this.baselineScenarioList = data.baseScenarioItems;
        this.impactCategoriesList = data.impactCategoryItems;
        if (this.impactCategoriesList) {
          this.setupImpactCategories(this.impactCategoriesList);
        }
        this.includeCategoriesList = data.indicatorItems;
        break;
    }
  }

  setupImpactCategories(data: any) {
    const isPEFCategoriesDisabled = !isFeatureEnabled(
      FeatureCodes.REPORTS_PEF_CATEGORIES_WITH_TOXICITY
    );
    this.impactCategoriesList = data.map((item: any) => {
      if (
        item.id === this.PEF_CATEGORIES_WITH_TOXICITY ||
        item.id === this.PEF_CATEGORIES_WITHOUT_TOXICITY
      ) {
        return {
          ...item,
          disabled: isPEFCategoriesDisabled,
          isFeatureDisabled: isPEFCategoriesDisabled,
        };
      }
      return item;
    });
  }

  async getFunctionalUnitList() {
    await this.functionalUnitList.map((data: any) => {
      if (data.id == this.alllReportData.functionalUnitId) {
        this.selectFuntionalUnitData = data;
      }
    });
  }

  async getBaselineScenarioList() {
    await this.baselineScenarioList?.map((data: any) => {
      if (data.idStr == this.alllReportData?.ecoDesignedPackageId) {
        this.selectBaselineScenarioListData = data;
      }
    });
  }
  async getImpactCategoriesList() {
    await this.impactCategoriesList?.map((data: any) => {
      if (data.id == this.alllReportData?.impactCategoryId) {
        this.selectImpactCategoriesListData = data;
        if (this.selectImpactCategoriesListData?.id == this.CUSTOM_CATEGORY) {
          this.hideShowCategoriesToInclude(this.selectImpactCategoriesListData);
        }
      }
    });
  }
  async getAdditionalInformationList() {
    await this.additionalInformationList?.map((data: any) => {
      if (data.id == this.alllReportData?.additionalCategoryId) {
        this.selectAdditionalInformationListData = data;
      }
    });
  }

  //match id for scenario

  getMatchingScenarioIds(dataArray: any, fullReportScenarioIds: any) {
    const matchingIds: any = [];
    dataArray?.forEach((item: any) => {
      if (fullReportScenarioIds?.includes(item.idStr)) {
        matchingIds.push(item.idStr);
      }
    });
    return matchingIds;
  }

  // Patch report form-controls
  pathchFormControls(data: any) {
    switch (data.reportFormatId) {
      case 3:
      case 4:
      case 6:
      case 8:
      case 11:
      case 12:
      case 13:
      case 0:
        this.getFunctionalUnitList();
        this.getBaselineScenarioList();
        this.getImpactCategoriesList();
        this.getAdditionalInformationList();
        const scenarioBindIds = this.getMatchingScenarioIds(
          data?.fullReportProductPackageScenarioItems,
          data.fullReportScenarioIds?.split(',')
        );
        const defaultSelectedIds = data.reportIndicators
          ? data.reportIndicators?.split(',').map(Number)
          : null;
        this.reportChartForm.patchValue({
          includeScenario: data.fullReportScenarioIds ? scenarioBindIds : null,
          excludeProductImpacts: data.isExcludeProductImpacts,
          functionalUnit: this.selectFuntionalUnitData,
          // baselineScenario: data.ecoDesignedPackageId > 0 ? (data.ecoDesignedPackageId).toString() : null,
          baselineScenario: this.selectBaselineScenarioListData,
          // impactCategories: data.impactCategoryId > 0 ? data.impactCategoryId : null,
          impactCategories: this.selectImpactCategoriesListData,
          includeCategories: defaultSelectedIds?.filter((id: any) =>
            this.includeCategoriesList.map((option: any) => option.id).includes(id)
          ),
          additionalInformation: this.selectAdditionalInformationListData,
          reportTitle: data.projectName,
        });
        this.selectedBaseScenario = this.selectBaselineScenarioListData?.idStr;
        if (this.reportChartForm.controls['baselineScenario'].invalid) {
          this.isEnableAllScenarioDrp = true;
        } else {
          this.isEnableAllScenarioDrp = false;
        }

        if (data?.sensitivityAnalysisList?.length) {
          const itemsArray = this.sensitivityReportForm.get('items') as FormArray;
          itemsArray.clear();
          data?.sensitivityAnalysisList.forEach((x: any) => {
            this.addItem(x);
          });
        }
        break;
      case 5:
        this.getFunctionalUnitList();
        this.getBaselineScenarioList();
        this.getImpactCategoriesList();
        this.getAdditionalInformationList();
        const scenarioBindForExport = this.getMatchingScenarioIds(
          data?.productPackageScenarioItems,
          data.exportScenarioIds.split(',')
        );
        this.reportChartForm.patchValue({
          includeScenario: scenarioBindForExport,
          excludeProductImpacts: data.isExcludeProductImpacts,
          functionalUnit: this.selectFuntionalUnitData,
          baselineScenario: this.selectBaselineScenarioListData,
          impactCategories: this.selectImpactCategoriesListData,
          includeCategories: data.reportIndicators.split(',').map(Number),
        });
        break;
      case 7:
      case 10:
        this.getFunctionalUnitList();
        this.getBaselineScenarioList();
        this.getImpactCategoriesList();
        this.getAdditionalInformationList();
        const scenarioBindForLCA = this.getMatchingScenarioIds(
          data?.fullReportProductPackageScenarioItems,
          data.fullReportScenarioIds?.split(',')
        );
        this.reportChartForm.patchValue({
          includeScenario: data.fullReportScenarioIds ? scenarioBindForLCA : null,
          excludeProductImpacts: data.isExcludeProductImpacts,
          includeInputInformation: data.isIncludeInputInformation,
          functionalUnit: this.selectFuntionalUnitData,
          baselineScenario: this.selectBaselineScenarioListData,
          impactCategories: this.selectImpactCategoriesListData,
          includeCategories: data.reportIndicators.split(',').map(Number),
          reportTitle: data.projectName,
        });
        break;
      default:
        this.getFunctionalUnitList();
        this.getBaselineScenarioList();
        this.getImpactCategoriesList();
        this.getAdditionalInformationList();
        this.reportChartForm.patchValue({
          includeScenario: data.exportScenarioIds ? data.exportScenarioIds.split(',') : null,
          excludeProductImpacts: data.isExcludeProductImpacts,
          functionalUnit: this.selectFuntionalUnitData,
          baselineScenario: this.selectBaselineScenarioListData,
          impactCategories: this.selectImpactCategoriesListData,
          includeCategories: data.reportIndicators
            ? data.reportIndicators.split(',').map(Number)
            : null,
        });
        break;
    }
    // this.getMaterialDataForISOreport();
  }

  // hide show Dropdowns based on report format
  hideShowDropdowns(reportFormatId: any) {
    this.isShowAdditionalInformationToInclude =
      reportFormatId === 3 || reportFormatId === 4 ? true : false;
    this.isShowReportTitle = reportFormatId === 5 ? false : true;
    this.isDisabledSelectImpactCategories = reportFormatId === 8 ? true : false;
  }

  isExcludeProduct() {
    this.reportService
      .getChartCompareTypeProductWise(this.reportChartForm.controls['excludeProductImpacts'].value)
      .subscribe((data: any) => {});
  }

  // Get Multiselect array for Include Scenarios
  multiSelectIncludeScenarios(event: any) {
    this.includeScenariosPayloadArray = event;
    // this.getMaterialDataForISOreport();
  }

  // Get Multiselect array for Include Categories
  multiSelectIncludeCategories(event: any) {
    this.includeCategoriesPayloadArray = event;
  }

  // Get Multiselect array for Additional Information
  multiSelectAdditionalInformation(event: any) {
    this.additionalInformationPayloadArray = event;
  }

  getCustomReport() {
    this.reportService
      .getReportTypeByReportFormat(this.isCheckeportListByFormateById)
      .subscribe((data: any) => {
        data?.data[1].childItems.length == 0 &&
          data?.data[1].childItems.push(commonEnum.dummyRecord);
        // Tag each child item with its parent category ID
        data?.data.forEach((category: any) => {
          if (category.childItems) {
            category.childItems.forEach((item: any) => {
              item._categoryId = category.id;
            });
          }
        });
        this.reportListByFormate = data?.data.filter(
          (category: any) =>
            category.id !== 3 || (category.childItems && category.childItems.length > 0)
        );
        if (!this.isReportGeneratable && this.checkSelectedReportType(data?.data[1]))
          this.isReportGeneratable = true;
      });
  }

  checkSelectedReportType(data: any) {
    const selectedCustomReport = data.childItems.find(
      (obj: any) => obj.id == this.isCheckeportListByTypeById && obj.isReportGeneratable
    );
    return selectedCustomReport ? true : false;
  }

  exportPDF(projectName: any) {
    this.pdfData?.saveAs(projectName.projectName + '.pdf');
    setTimeout(() => {
      this.isShowSimpleDeck = false;
    }, 5000);
  }

  exportPDFSlides(projectName: any) {
    this.pdfDataSecond?.saveAs(projectName.projectName + '.pdf');
    setTimeout(() => {
      this.isShowSlides = false;
    }, 4000);
  }

  private validateReportFeatures(payload: any): string[] {
    const validations: FeatureValidation[] = [];
    const checkReportName = this.reportChartForm.controls['reportFormatByList'].value;
    if (checkReportName && checkReportName.name == this.ISO_REPORT_TEXT) {
      validations.push({
        condition: true,
        featureCode: this.FeatureCodes.REPORTS_ISO_14044_LCA_REPORT,
        featureName: this.ISO_REPORT_TEXT,
      });
    }

    // Check if Custom Report is being generated
    if (payload.isCustomType) {
      validations.push({
        condition: true,
        featureCode: this.FeatureCodes.REPORTS_CUSTOM_REPORT,
        featureName: 'Custom Report',
      });
    }

    // Check if sensitivity analysis is included
    if (payload.sensitivityAnalysisList && payload.sensitivityAnalysisList.length > 0) {
      validations.push({
        condition: true,
        featureCode: this.FeatureCodes.REPORTS_SENSITIVITY_ANALYSIS,
        featureName: 'Sensitivity Analysis',
      });
    }

    return validateFeatures(validations, isFeatureEnabled);
  }

  async onGenerateReport(type?: string) {
    this.finalSubmit = true;
    if (this.reportChartForm.invalid) {
      return;
    } else {
      const baseScenarioId = Number(this.reportChartForm.controls['baselineScenario'].value.idStr);
      let scenariosList = this.reportChartForm.controls['includeScenario'].value || [];
      if (!Array.isArray(scenariosList)) {
        scenariosList = scenariosList.toString().split(',');
      }

      scenariosList = scenariosList.map((id: any) => id.toString());

      if (this.reportType === 1) {
        // LCA Report
        const existingIndex = scenariosList.indexOf(baseScenarioId.toString());

        if (existingIndex !== -1) {
          scenariosList.splice(existingIndex, 1);
        }

        scenariosList.unshift(baseScenarioId.toString());
      } else if (this.reportType === 2) {
        // LCA Presentation
        if (scenariosList.length > 1 && scenariosList.includes(baseScenarioId.toString())) {
          scenariosList = scenariosList.filter((id: any) => id !== baseScenarioId.toString());
        }
      }

      const additionalElementsids = this.additionalInformationList?.map((item: any) => item.id);
      const formattedAdditionalElementsids = additionalElementsids?.join(',');
      const includeCategoriesList = this.includeCategoriesList?.map((item: any) => item.id);
      const formattedincludeCategoriesIds = includeCategoriesList?.join(',');
      const payload: any = {
        projectId: Number(this.currentProjectId),
        reportFormatId: this.reportTypeIdByList,
        newReportFormatId: this.isCheckeportListByFormateById,
        newReportTypeId: this.isCheckeportListByTypeById ? this.isCheckeportListByTypeById : 0,
        // scenarioIds : includeScenariosIds.toString(),
        scenarioIds: scenariosList.toString(),
        baseScenarioId: Number(this.reportChartForm.controls['baselineScenario'].value.idStr),
        // customize categoryId =  7
        impactCategoryId: this.isCheckeportListByTypeByFlag
          ? 7
          : this.reportChartForm.controls['impactCategories'].value.id,
        // indicatorsId: this.reportChartForm.controls['includeCategories'].value ? this.reportChartForm.controls['includeCategories'].value.toString() : '',
        indicatorsId: this.isCheckeportListByTypeByFlag
          ? formattedincludeCategoriesIds.toString()
          : !!this.reportChartForm.controls['includeCategories'].value &&
            this.reportChartForm.controls['includeCategories'].value.length != 0
          ? this.reportChartForm.controls['includeCategories'].value.toString()
          : formattedincludeCategoriesIds.toString(),
        functionUnitId: this.reportChartForm.controls['functionalUnit'].value.id,
        additionalElements: this.isShowIncludeInputInformation
          ? '0'
          : this.additionalInformationList
          ? formattedAdditionalElementsids
          : '',
        // additionalElements: !!this.additionalInformationList ? formattedAdditionalElementsids : '',
        // isExcludeProductImpacts : this.reportChartForm.controls['excludeProductImpacts'].value,
        isExcludeProductImpacts: false,
        isIncludeInputInformation: this.reportChartForm.controls['includeInputInformation'].value,
        reportName: this.reportChartForm.controls['reportTitle']?.value,
        indicatorId: '',
        scenarioId: Number(this.reportChartForm.controls['baselineScenario'].value.idStr),

        // For testing, this two flags are default false, need to change after
        isExport: this.isShowIncludeInputInformation ? true : false,
        isNavigate: false,
        isCustomType: this.isCheckeportListByTypeByFlag,
        // extra
        reportTypeId: this.reportChartForm.controls['functionalUnit'].value.id,
        equivalentPackageScenarioId: 0,
        reportGeneratedDate: formatDate(Date.now(), 'yyyy-MM-dd HH:mm', 'en-US'),
      };
      const itemsArray = this.sensitivityReportForm.get('items') as FormArray;
      const lstSensitivityAnalysis: any[] = []; // Initialize the array

      // Check if itemsArray is not null
      if (itemsArray) {
        // Loop over the length of the itemsArray
        for (let i = 0; i < itemsArray.length; i++) {
          const item = itemsArray.at(i) as FormGroup | null; // Access individual item as FormGroup or null
          if (
            item?.get('addRefrences')?.value ||
            item?.get('variationOne')?.value ||
            item?.get('variationTwo')?.value ||
            item?.get('variationThree')?.value ||
            item?.get('variationFour')?.value
          ) {
            const sensitivityAnalysis: any = {
              referenceSensitivityAnalysis: item.get('addRefrences')?.value,
              variationOne: item.get('variationOne')?.value,
              variationTwo: item.get('variationTwo')?.value,
              variationThree: item.get('variationThree')?.value,
              variationFour: item.get('variationFour')?.value,
            };
            const variations = ['variationOne', 'variationTwo', 'variationThree', 'variationFour'];
            for (let i = 0; i < variations.length - 1; i++) {
              const currentVariation = variations[i];
              const nextVariation = variations[i + 1];
              if (
                sensitivityAnalysis[currentVariation] === null &&
                sensitivityAnalysis[nextVariation] !== null
              ) {
                sensitivityAnalysis[currentVariation] = sensitivityAnalysis[nextVariation];
                sensitivityAnalysis[nextVariation] = null;
              }
            }
            if (
              !!sensitivityAnalysis.referenceSensitivityAnalysis &&
              !item?.get('variationOne')?.value &&
              !item?.get('variationTwo')?.value &&
              !item?.get('variationThree')?.value &&
              !item?.get('variationFour')?.value
            ) {
              this.isCheckVariation = true;
              this.errorIndex = i;
              return;
            }
            lstSensitivityAnalysis.push(sensitivityAnalysis);
          }
        }
      }
      payload['sensitivityAnalysisList'] = lstSensitivityAnalysis;
      // lstSensitivityAnalysis.length > 0
      //   ? this.sharedService.show(
      //       'Adding a sensitivity analysis requires more load time... <br> Hold on tight..this may take a minute or two'
      //     )
      //   : this.sharedService.show('Hold on tight.. This may take a minute or two.');
      if (this.isShowIncludeInputInformation) {
        payload['userId'] = this.cookieService.get('userId');
      }
      payload.reportType = this.reportTypeIdByList;
      payload.loaderMessage =
        lstSensitivityAnalysis.length > 0
          ? `Adding a sensitivity analysis requires more load time... <br> ${sensitivityLoaderMessage}`
          : loaderMessage;
      const missingFeatures = this.validateReportFeatures(payload);
      if (missingFeatures.length > 0) {
        showFeatureAlert(missingFeatures, this.swalService);
        return;
      }
      const hasSensitivityAnalysis = lstSensitivityAnalysis.length > 0;
      const hasMoreThanFourScenarios = scenariosList.length >= 4;
      const isShareReport =
        this.reportChartForm.controls['newFormateList'].value?.name?.toLowerCase() !=
          this.lcaPresentenceText &&
        this.reportChartForm.controls['newFormateList'].value?.name?.toLowerCase() !=
          this.EXPORT_RAW_DATA;
      if (
        (hasMoreThanFourScenarios || hasSensitivityAnalysis) &&
        type !== 'save' &&
        type !== 'shareReport' &&
        isShareReport
      ) {
        const isReportBuilderTemplate = this.reportTypeIdByList == 13;

        // Report-builder templates skip the "wait / cancel" popup entirely —
        // generation proceeds straight away. The popup is only used for the
        // other report types where the alternative is "email me".
        if (!isReportBuilderTemplate) {
          const swalPayload: ConfirmPayload = {
            title: 'Report generation',
            text: `Your report may take some time to generate. Would you like us to send it directly to your email instead of waiting here?`,
            icon: 'warning',
            iconHtml: '',
            showCancelButton: true,
            confirmButtonText: 'Email me',
            cancelButtonText: 'Wait here',
            reverseButtons: true,
            allowOutsideClick: false,
            customClass: 'Popupbackground email-report-confirmation',
            iconColor: '#FFFFFF',
            enableAnimation: false,
          };

          const confirmed = await this.swalService.confirmLegacy(swalPayload);

          if (confirmed) {
            return this.openShareModal();
          }
        }
      }
      switch (this.reportTypeIdByList) {
        case 12:
          if (type == 'save') {
            const isoReportRes = await this.reportService.saveLCAReportDetails(payload);
            isoReportRes.messageType == 0
              ? this.toaster.success('Report details have been successfully saved.')
              : this.toaster.error(isoReportRes.message);
          } else {
            payload.flag = this.isCheckeportListByTypeByFlag;
            payload.isCheckeportListByTypeById = this.isCheckeportListByTypeById;
            payload.isCheckeportListByFormateById = this.isCheckeportListByFormateById;
            if (type != 'shareReport') {
              payload['APIToken'] = this.cookieService.get('token');
              payload.indicatorId = payload.indicatorId == '' ? 0 : payload.indicatorId;
              payload.isReportGenerated = false;
              payload.isExport = true;
              this.downloadPDF(
                payload,
                'PDFGenerator/ProductLCAReport?requestString',
                '_SummaryReport'
              );
            } else {
              this.pdfExport(payload);
            }
          }
          break;
        case 3:
          if (type == 'save') {
            const isoReportRes = await this.reportService.saveLCAReportDetails(payload);
            isoReportRes.messageType == 0
              ? this.toaster.success('Report details have been successfully saved.')
              : this.toaster.error(isoReportRes.message);
          } else {
            payload.flag = this.isCheckeportListByTypeByFlag;
            payload.isCheckeportListByTypeById = this.isCheckeportListByTypeById;
            payload.isCheckeportListByFormateById = this.isCheckeportListByFormateById;

            if (type != 'shareReport') {
              const queryParams: any = {
                payload: encrypt(JSON.stringify(payload)),
              };

              const queryString = Object.keys(queryParams)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParams[key])}`)
                .join('&');

              const newWindow = window.open(
                `/#/projects/project-detail-report?${queryString}`,
                '_blank'
              );

              if (newWindow === null) {
              } else {
              }
            } else {
              this.pdfExport(payload);
            }
          }
          break;
        case 4:
          if (type == 'save') {
            const responseCompact = await this.reportService.saveLCAReportDetails(payload);
            responseCompact.messageType == 0
              ? this.toaster.success('Report details have been successfully saved.')
              : this.toaster.error(responseCompact.message);
          } else {
            payload.flag = this.isCheckeportListByTypeByFlag;
            payload.isCheckeportListByTypeById = this.isCheckeportListByTypeById;
            payload.isCheckeportListByFormateById = this.isCheckeportListByFormateById;
            if (type != 'shareReport') {
              const queryParams: any = {
                payload: encrypt(JSON.stringify(payload)),
              };
              const queryString = Object.keys(queryParams)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParams[key])}`)
                .join('&');

              window.open(`/#/projects/project-detail-report?${queryString}`, '_blank');
            } else {
              this.pdfExport(payload);
            }
          }
          break;
        case 5:
          this.sharedService.show(loaderMessage);
          this.spinner.show();
          const responsePdf = await this.runReportJob('StartExportCsv', payload, () =>
            this.reportService.getExcelSummaryLink(payload)
          );
          this.spinner.hide();
          this.sharedService.show('');
          if (responsePdf.messageType === 0) {
            const downloadLink = document.createElement('a');
            downloadLink.href = responsePdf.data;
            downloadLink.download = 'report.pdf';
            downloadLink.click();
          } else {
            this.errorGenerateReport(payload, responsePdf);
          }
          break;
        case 6:
          if (type == 'save') {
            const responseProductWaste = await this.reportService.generateProductWasteReport(
              payload
            );
            responseProductWaste.messageType == 0
              ? this.toaster.success(responseProductWaste.message)
              : this.toaster.error(responseProductWaste.message);
          } else {
            payload.flag = this.isCheckeportListByTypeByFlag;
            payload.isCheckeportListByTypeById = this.isCheckeportListByTypeById;
            payload.isCheckeportListByFormateById = this.isCheckeportListByFormateById;
            this.route.navigate(['projects/project-detail-report'], {
              queryParams: {
                payload: encrypt(JSON.stringify(payload)),
              },
            });
          }

          break;
        case 7:
          payload['APIToken'] = this.cookieService.get('token');
          payload.indicatorId = payload.indicatorId == '' ? 0 : payload.indicatorId;
          this.isShowSimpleDeck = true;
          this.downloadPDF(
            payload,
            'PDFGenerator/SlideDeckReports?reuqestString',
            '_LCA Presentation'
          );
          break;
        case 8:
          if (type == 'save') {
            const responseCarbon = await this.reportService.generateCarbonFootprintReport(payload);
            responseCarbon.messageType == 0
              ? this.toaster.success(responseCarbon.message)
              : this.toaster.error(responseCarbon.message);
          } else {
            // const responseCarbon = await this.reportService.generateCarbonFootprintReport(payload);
            // this.sharedService.show('');
            // if (responseCarbon.messageType === 0) {
            payload.flag = this.isCheckeportListByTypeByFlag;
            payload.isCheckeportListByTypeById = this.isCheckeportListByTypeById;
            payload.isCheckeportListByFormateById = this.isCheckeportListByFormateById;
            this.route.navigate(['projects/project-detail-report'], {
              queryParams: {
                payload: encrypt(JSON.stringify(payload)),
              },
            });
          }
          break;
        case 10:
          payload['APIToken'] = this.cookieService.get('token');
          payload.indicatorId = payload.indicatorId == '' ? 0 : payload.indicatorId;
          this.isShowSlides = true;
          this.downloadPDF(
            payload,
            'PDFGenerator/SlideReport?reuqestString',
            '_LCA Scenario Slides'
          );
          break;
        case 11: // ISO  Report
        case 0: // custom   Report
          if (type == 'save') {
            const isoReportRes = await this.reportService.saveLCAReportDetails(payload);
            isoReportRes.messageType == 0
              ? this.toaster.success('Report details have been successfully saved.')
              : this.toaster.error(isoReportRes.message);
          } else {
            if (this.reportTypeIdByList == 0) {
              payload.reportTypeIdByList = this.reportTypeIdByList;
              payload.reportFormatId = 0;
              payload.flag = this.isCheckeportListByTypeByFlag;
              payload.isCheckeportListByTypeById = this.isCheckeportListByTypeById;
              payload.isCheckeportListByFormateById = this.isCheckeportListByFormateById;
            }
            if (type != 'shareReport') {
              const queryParams: any = {
                payload: encrypt(JSON.stringify(payload)),
              };

              // Construct the query parameters string
              const queryString = Object.keys(queryParams)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParams[key])}`)
                .join('&');

              // Open the new tab with the desired route and query parameters
              window.open(`/#/projects/project-detail-report?${queryString}`, '_blank');
            } else {
              this.pdfExport(payload);
            }
            // } else {
            //   this.errorGenerateReport(payload, resISOReport);
            // }
          }
          break;
        case 14:
          this.sharedService.show(loaderMessage);
          this.spinner.show();
          const res = await this.runReportJob('StartExportCsvNew', payload, () =>
            this.reportService.getProductExcelSummaryLinkNew(payload)
          );
          this.spinner.hide();
          this.sharedService.show('');
          if (res.messageType === 0) {
            const downloadLink = document.createElement('a');
            downloadLink.href = res.data;
            downloadLink.download = 'report.pdf';
            downloadLink.click();
          } else {
            this.errorGenerateReport(payload, res);
          }
          break;
        case 13: // Report Template
          if (type == 'save') {
            const templateSaveRes = await this.reportService.saveLCAReportDetails(payload);
            templateSaveRes.messageType == 0
              ? this.toaster.success('Report details have been successfully saved.')
              : this.toaster.error(templateSaveRes.message);
          } else {
            payload.flag = this.isCheckeportListByTypeByFlag;
            payload.isCheckeportListByTypeById = this.isCheckeportListByTypeById;
            payload.isCheckeportListByFormateById = this.isCheckeportListByFormateById;
            payload.templateId = this.isCheckeportListByTypeById;
            if (type != 'shareReport') {
              // Pass payload via encrypted query param (same pattern as other reports)
              // New tab calls the API itself — avoids popup blocker from async await
              const queryParams: any = {
                payload: encrypt(JSON.stringify(payload)),
                templateId: this.isCheckeportListByTypeById,
              };
              const queryString = Object.keys(queryParams)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParams[key])}`)
                .join('&');
              window.open(
                `/#/report-builder/report-preview/${this.isCheckeportListByTypeById}?source=project&${queryString}`,
                '_blank'
              );
            } else {
              this.pdfExport(payload);
            }
          }
          break;
      }
      this.finalSubmit = false;
    }
  }

  onExporttoExcelProject() {
    this.sharedService.show(loaderMessage);
    this.reportService
      .exportToExcelSummaryLink(Number(this.currentProjectId))
      .subscribe((response: any) => {
        this.sharedService.show('');
        if (response.messageType === 0) {
          const downloadLink = document.createElement('a');
          downloadLink.href = response.data;
          downloadLink.download = 'report.xlsx';
          downloadLink.click();
        } else {
          this.toaster.error('Failed to export report');
        }
      });
  }

  // Triggered by the "Export project summary" Report Format option.
  // Calls the same Report/ExportProject endpoint as the standard export.
  onExportProjectSummary() {
    // Collect the selected scenarios from the "Scenarios to include" multi-select.
    // The form value is either an array of ids, a comma-separated string,
    // or null/undefined when nothing is selected.
    const rawSelection = this.reportChartForm.controls['includeScenario']?.value;
    let rawScenarioIds: any[] = [];
    if (Array.isArray(rawSelection)) {
      rawScenarioIds = rawSelection;
    } else if (rawSelection !== null && rawSelection !== undefined && rawSelection !== '') {
      rawScenarioIds = String(rawSelection)
        .split(',')
        .map(s => s.trim())
        .filter(s => s.length > 0);
    }

    // Backend expects integer ids. Drop any values that don't parse as a
    // finite number so we never POST NaN.
    const scenarioIds: number[] = rawScenarioIds
      .map((id: any) => Number(id))
      .filter((id: number) => Number.isFinite(id));

    const payload: ExportProjectSummaryPayload = {
      projectId: Number(this.currentProjectId),
      scenarioIds: scenarioIds,
      isShowReportDetails: this.isShowReportDetailsForExportSummary,
    };

    if (this.isExporting) {
      return;
    }
    this.isExporting = true;
    // The SignalR path makes no HTTP request, so the HTTP interceptor that
    // normally drives the global spinner never fires. Show it explicitly here
    // (and hide it in finishExport) so the loader + status are visible.
    this.spinner.show();
    this.startStatusTicker(this.exportLoaderMessage);

    // Stream the heavy export over SignalR. Live progress updates the spinner
    // message; a connection failure (3 attempts exhausted) falls back to the
    // legacy synchronous POST so export still works.
    this.exportSub = this.reportExportSignalr.exportProject(payload).subscribe({
      next: ev => {
        if (ev.kind === 'progress') {
          this.enqueueStatus(ev.message || this.exportLoaderMessage);
        } else {
          this.finishExport();
          this.downloadExportResult(ev.result);
        }
      },
      error: err => {
        if (err instanceof ExportConnectionFailedError) {
          // Fall back to the legacy synchronous POST; it manages its own cleanup.
          this.exportProjectSummaryHttpFallback(payload);
        } else {
          this.finishExport();
          this.toaster.error('Failed to export project summary');
        }
      },
    });
  }

  private finishExport() {
    this.isExporting = false;
    this.stopStatusTicker();
    this.spinner.hide();
    this.sharedService.show('');
  }

  private startStatusTicker(initialMessage: string) {
    this.stopStatusTicker();
    this.currentStatusBase = this.stripTrailingDots(initialMessage);
    this.pendingStatusBase = null;
    this.currentStatusShownAt = Date.now();
    this.statusDotPhase = 0;
    this.renderStatus();
    this.statusTimer = setInterval(() => this.tickStatus(), this.STATUS_TICK_MS);
  }

  // Bursts collapse to the latest message so a fast export isn't padded out.
  private enqueueStatus(message: string) {
    const base = this.stripTrailingDots(message);
    if (!base || base === this.currentStatusBase) {
      return;
    }
    this.pendingStatusBase = base;
  }

  private tickStatus() {
    if (!this.isExporting) {
      return;
    }
    if (
      this.pendingStatusBase !== null &&
      Date.now() - this.currentStatusShownAt >= this.MIN_STEP_MS
    ) {
      this.currentStatusBase = this.pendingStatusBase;
      this.pendingStatusBase = null;
      this.currentStatusShownAt = Date.now();
      this.statusDotPhase = 0;
    } else {
      this.statusDotPhase = (this.statusDotPhase + 1) % 4;
    }
    this.renderStatus();
  }

  private renderStatus() {
    this.sharedService.show(this.currentStatusBase + '.'.repeat(this.statusDotPhase));
  }

  private stopStatusTicker() {
    if (this.statusTimer) {
      clearInterval(this.statusTimer);
      this.statusTimer = null;
    }
  }

  private stripTrailingDots(message: string): string {
    return (message || '').replace(/[.…\s]+$/, '');
  }

  // Streams a report-generation job over SignalR and resolves with the same
  // { messageType, data } shape the POST endpoint returns, so the caller's
  // success/error branches stay unchanged. Progress messages drive the loader
  // text via sharedService.show; a connection failure falls back to the
  // original HTTP call. Server failures / timeouts resolve a non-zero
  // messageType so the existing error path handles them.
  private runReportJob(
    hubMethod: ReportHubMethod,
    payload: any,
    httpFallback: () => Promise<any>
  ): Promise<any> {
    return new Promise(resolve => {
      let resolved = false;
      const done = (value: any) => {
        if (resolved) return;
        resolved = true;
        resolve(value);
      };

      this.exportSub = this.reportExportSignalr.generateReport(hubMethod, payload).subscribe({
        next: ev => {
          if (ev.kind === 'progress') {
            this.sharedService.show(ev.message || payload.loaderMessage || 'Working…');
          } else {
            done({
              messageType: ev.result.messageType,
              data: ev.result.data ? JSON.parse(ev.result.data) : null,
              message: ev.result.message,
            });
          }
        },
        error: err => {
          if (err instanceof ExportConnectionFailedError) {
            httpFallback()
              .then(done)
              .catch(() => done({ messageType: 1, message: 'Failed to generate report' }));
          } else {
            done({ messageType: 1, message: (err && err.message) || 'Failed to generate report' });
          }
        },
      });
    });
  }

  private downloadExportResult(result: ExportResult) {
    if (result?.messageType === 0 && result.data) {
      this.downloadAndCleanup(result.data, result.fileName || this.fileNameFromUrl(result.data));
    } else {
      this.toaster.error('Failed to export project summary');
    }
  }

  // Save the file locally before deleting the server copy, so deletion never
  // races the download. If the blob fetch fails, fall back to a direct link
  // download and leave the server copy for the server-side cleanup job.
  private downloadAndCleanup(url: string, fileName: string) {
    const name = fileName || 'project_summary.xlsm';
    fetch(url)
      .then(res => {
        if (!res.ok) {
          throw new Error(`Download failed with status ${res.status}`);
        }
        return res.blob();
      })
      .then(blob => {
        saveAs(blob, name);
        this.reportService.deleteExportProjectFile(name).subscribe({
          error: () => {
            /* best-effort cleanup; a failed delete must not surface to the user */
          },
        });
      })
      .catch(() => {
        const downloadLink = document.createElement('a');
        downloadLink.href = url;
        downloadLink.download = name;
        downloadLink.click();
      });
  }

  private fileNameFromUrl(url: string): string {
    const lastSegment = (url || '').split('/').pop() || '';
    return lastSegment.split('?')[0] || 'project_summary.xlsm';
  }

  // Legacy path: a single synchronous POST that blocks until the server is done.
  // Used only when the SignalR connection can't be established.
  private exportProjectSummaryHttpFallback(payload: ExportProjectSummaryPayload) {
    this.reportService.exportProjectSummary(payload).subscribe({
      next: (response: any) => {
        this.finishExport();
        if (response?.messageType === 0) {
          this.downloadAndCleanup(response.data, this.fileNameFromUrl(response.data));
        } else {
          this.toaster.error('Failed to export project summary');
        }
      },
      error: () => {
        this.finishExport();
        this.toaster.error('Failed to export project summary');
      },
    });
  }

  errorGenerateReport(payload: any, response: any) {
    this.swalService
      .confirm(
        'Report this issue',
        'An error occurred while generating your report. Do you want to report this issue to the Piqet team?'
      )
      .then(confirmed => {
        if (confirmed) {
          this.openReportBugModal(payload, response);
        }
      });
  }

  openReportBugModal(payload: any, response: any) {
    this.modal.invoke('reportBug', {
      initialState: {
        payload,
        response,
        categoryInfo: getReportGenerationBugId(),
      },
      class: 'modal-xl',
    });
  }

  downloadPDF(payload: any, generateURL: any, type: any) {
    this.sharedService.show(loaderMessage);
    this.reportService.directGenertePDF(payload, generateURL).subscribe(
      blob => {
        const fileName = payload.reportName + type;

        this.reportService.processPdfBlobResponse(blob, {
          payload: payload,
          fileName: fileName,
          fileExtension: '.pdf',
          onError: (payload, error) => {
            this.errorGenerateReport(payload, error);
            this.sharedService.show('');
          },
          onSuccess: () => {
            this.sharedService.show('');
          },
        });
      },
      error => {
        this.errorGenerateReport(payload, error);
        this.sharedService.show('');
      }
    );
  }

  downloadHtml(payload: any, generateURL: any, type: any) {
    this.reportService.directGenertePDF(payload, generateURL).subscribe(
      blob => {
        const fileName = payload.reportName + type;

        this.reportService.processPdfBlobResponse(blob, {
          payload: payload,
          fileName: fileName,
          fileExtension: '.html',
          onError: (payload, error) => {
            this.errorGenerateReport(payload, error);
            this.sharedService.show('');
          },
          onSuccess: () => {
            this.sharedService.show('');
          },
        });
      },
      error => {
        this.errorGenerateReport(payload, error);
        this.sharedService.show('');
      }
    );
  }

  fileChangeEvent(event: any) {
    const reader = new FileReader(); // HTML5 FileReader API
    this.selectedFileName = event.target.files[0].name;
    this.isShowChange = this.selectedFileName ? true : false;
    const file = event.target.files[0];
    const mimeType = file?.type;
    if (
      mimeType?.match(/image\/*/) == null ||
      (mimeType != 'image/png' &&
        mimeType != 'image/jpg' &&
        mimeType != 'image/jpeg' &&
        mimeType != 'image/gif')
    ) {
      this.isImageValid = false;
      return;
    } else {
      this.isImageValid = true;
      if (event.target.files && event.target.files[0]) {
        reader.readAsDataURL(file);
        reader.onload = (e: any) => {
          this.imageUrl = reader.result;
          this.fileBase64 = this.imageUrl.split(',')[1];
          this.iserror = false;
        };
      }
    }
  }

  changeImageOnHover(isHovered: boolean): void {
    this.isHovered = isHovered;
    if (this.disabledButton) {
      this.headerBtn = `<img class="fa fa-plus" width="45" height="45" src="${this.disableImageSrc}">`;
    } else {
      this.headerBtn = `<img class="fa fa-plus" width="45" height="45" src="${
        isHovered ? this.hoverImageSrc : this.originalImageSrc
      }">`;
    }
  }

  checkDisabledRef() {
    this.disabledButton = false;
    this.tooltipMessage = '';

    const itemsArray = this.sensitivityReportForm.get('items') as FormArray;
    const isSuperAdmin = this.decodeUserRole === superAdminRoleStr;

    const isInvalidItem = (item: FormGroup): boolean => {
      return (
        !item?.get('addRefrences')?.value ||
        (!item.get('variationOne')?.value &&
          !item.get('variationTwo')?.value &&
          !item.get('variationThree')?.value &&
          !item.get('variationFour')?.value)
      );
    };

    if (!isSuperAdmin && itemsArray.length >= 2) {
      this.disabledButton = true;
      this.tooltipMessage = 'You cannot add more than two sensitivity analyses.';
    } else {
      for (let i = 0; i < itemsArray.length; i++) {
        if (isInvalidItem(itemsArray.at(i) as FormGroup)) {
          this.disabledButton = true;
          break;
        }
      }
    }

    let imageSrc: string;

    if (this.disabledButton) {
      imageSrc = this.disableImageSrc;
    } else if (this.isHovered) {
      imageSrc = this.hoverImageSrc;
    } else {
      imageSrc = this.originalImageSrc;
    }

    this.headerBtn = `<img class="fa fa-plus" width="45" height="45" src="${imageSrc}">`;

    return this.disabledButton;
  }

  addItem(itemData?: any) {
    const itemsArrayCheckValue = this.sensitivityReportForm.get('items') as FormArray;
    for (let i = 0; i < itemsArrayCheckValue.length; i++) {
      const item: any = itemsArrayCheckValue.at(i) as FormGroup | null; // Access individual item as FormGroup or null
      if (
        !item?.get('addRefrences').value ||
        item?.get('addRefrences').value === null ||
        ((!item.get('variationOne').value || item.get('variationOne').value === null) &&
          (!item.get('variationTwo').value || item.get('variationTwo').value === null) &&
          (!item.get('variationThree').value || item.get('variationThree').value === null) &&
          (!item.get('variationFour').value || item.get('variationFour').value === null))
      ) {
        return;
      }
    }
    const variaton = this.baselineScenarioList?.filter(
      (x: any) => x.idStr != itemData?.referenceSensitivityAnalysis
    );
    this.variationLists = variaton;

    const isVariationIncluded = (variation: number | null) => {
      return this.variationLists.some((item: any) => item.idStr === variation?.toString());
    };
    const isAddRefrencesIncluded = (addRefrences: number | null) => {
      return this.baselineScenarioList.some((item: any) => item.idStr === addRefrences?.toString());
    };
    const itemFormGroup = this.formBuilder.group({
      addRefrences: [
        itemData && isAddRefrencesIncluded(itemData.referenceSensitivityAnalysis)
          ? JSON.stringify(itemData.referenceSensitivityAnalysis)
          : null,
      ],
      variationOne: [
        itemData &&
        isAddRefrencesIncluded(itemData.referenceSensitivityAnalysis) &&
        isVariationIncluded(itemData.variationOne)
          ? JSON.stringify(itemData.variationOne)
          : null,
      ],
      variationTwo: [
        itemData &&
        isAddRefrencesIncluded(itemData.referenceSensitivityAnalysis) &&
        isVariationIncluded(itemData.variationTwo)
          ? JSON.stringify(itemData.variationTwo)
          : null,
      ],
      variationThree: [
        itemData &&
        isAddRefrencesIncluded(itemData.referenceSensitivityAnalysis) &&
        isVariationIncluded(itemData.variationThree)
          ? JSON.stringify(itemData.variationThree)
          : null,
      ],
      variationFour: [
        itemData &&
        isAddRefrencesIncluded(itemData.referenceSensitivityAnalysis) &&
        isVariationIncluded(itemData.variationFour)
          ? JSON.stringify(itemData.variationFour)
          : null,
      ],
    });

    const itemsArray = this.sensitivityReportForm.get('items') as FormArray;
    if (itemData) {
      // Update existing item if it exists
      const existingItem = itemsArray.controls.find(
        control =>
          control.value.referenceSensitivityAnalysis === itemData.referenceSensitivityAnalysis
      );
      if (existingItem) {
        const existingItemIndex = itemsArray.controls.indexOf(existingItem);
        itemsArray.setControl(existingItemIndex, itemFormGroup);
      } else {
        // If not found, push a new item
        itemsArray.push(itemFormGroup);
      }
    } else {
      // If no itemData provided, add a new item
      itemsArray.push(itemFormGroup);
    }
  }

  removeSensitivityItem(index: number) {
    const itemsArray = this.sensitivityReportForm.get('items') as FormArray;
    itemsArray.removeAt(index);
    this.setHoveredIndex(null);
  }

  // getMaterialDataForISOreport() {
  //   let scenarioName = this.getDescriptionsByIdStr();
  //   if (!scenarioName) {
  //     this.dataQualityAssessmnetList = [];
  //     return;
  //   };
  //   this.reportService.getMaterialDataByScenarioIds(scenarioName, Number(this.currentProjectId)).subscribe((res: any) => {
  //     this.dataQualityAssessmnetList = res.data?.dataQualityAssessmentData;
  //     this.dataQualityAssementTechnologyList = res.data?.dataQualityAssessmentTechnologyData;
  //     this.ISOColumnDef = this.projectReportGenerationDataGridService.getDataQualityAssessmentListGrid();
  //     this.ISOColumnDef[5].cellEditorParams['technologyList'] = this.dataQualityAssementTechnologyList;
  //   });
  // }

  getDescriptionsByIdStr() {
    const idArray = this.reportChartForm.controls['includeScenario'].value
      .toString()
      .split(',')
      .map((s: string) => s.trim());
    const descriptions: any = [];

    this.includeScenarioList.forEach((item: any) => {
      if (idArray.includes(item.idStr)) {
        descriptions.push(item.description?.trim());
      }
    });
    return descriptions.join(',');
  }

  checkVariationValue(event: any, i: number, seq: number) {
    if (event?.idStr) {
      this.isCheckVariation = false;
    }
  }
  changeVariation(event: any, i: number, seq?: number) {
    const itemsArray = this.sensitivityReportForm.get('items') as FormArray;
    const item: any = itemsArray.at(i) as FormGroup | null;

    if (!item.get('addRefrences').value) {
      this.variationLists = [];
      return;
    }

    const variationKeys = ['variationOne', 'variationTwo', 'variationThree', 'variationFour'];
    const valueToRemove =
      seq && variationKeys[seq - 1] ? item.get(variationKeys[seq - 1]).value : null;

    const idList = Object.values(item.value);
    const indexToRemove = idList.indexOf(valueToRemove);

    if (indexToRemove !== -1) {
      idList.splice(indexToRemove, 1);
    }

    const filteredIdList = idList.filter(item => item !== null);
    const filteredVariationLists = this.baselineScenarioList.filter(
      (item: any) => !filteredIdList.includes(item.idStr)
    );

    this.variationLists = filteredVariationLists;
  }

  onPrev(step: string) {
    if (step == 'adv-14') {
      const url = location.href.split('/');
      const projectId = Number(atob(decodeURIComponent(customDecode(url[6]))));
      this.route.navigate(
        [
          `projects/projects-setting/${customEncode(
            btoa(encodeURIComponent(projectId))
          )}/interpretation`,
        ],
        { queryParams: { qPrm: 'UsawqPnfsdQnxc' } }
      );
      localStorage.setItem('scenarioName', 'Interpretation');
    }
  }

  onNext(step: string) {}

  removeElementAtIndex(position: any, array: any) {
    if (position < 0 || position >= array.length) {
      return;
    }
    array.splice(position, 1);
  }

  ngOnDestroy(): void {
    // Unsubscribing tears down any in-flight export SignalR connection.
    this.exportSub?.unsubscribe();
    this.stopStatusTicker();
    // Only clear the spinner we ourselves opened for an in-flight export, so we
    // never interfere with a spinner another flow may be showing.
    if (this.isExporting) {
      this.spinner.hide();
    }
    this.isExporting = false;
    this.sharedService.show('');
  }

  openShareModal() {
    this.finalSubmit = true;
    if (this.reportChartForm.invalid) {
      return;
    }
    this.modal.invoke('ReportShare', {
      class: 'modal-lg',
    });
    this.modal.ref?.content.exportOrShareReport.subscribe((exportOrShareReport: any) => {
      return of(
        (this.userList = exportOrShareReport.payload),
        this.onGenerateReport('shareReport')
      );
    });
  }

  sendReportMail(payload: any, generateURL: any) {
    const newPayload = { ...payload, userList: this.userList };

    this.reportService.directGenertePDF(newPayload, generateURL).subscribe({
      next: blob => {
        this.reportService.processMailReportResponse(blob, {
          payload: newPayload,
          onError: (payload, error) => this.errorGenerateReport(payload, error),
          onMailSuccess: () => {
            this.toaster.success('Your report will be shared via your email shortly');
            this.modal.close();
          },
        });
      },
      error: error => {
        this.errorGenerateReport(newPayload, error);
      },
    });
  }
  async pdfExport(data: any) {
    this.exportPayload = data;
    this.exportPayload.isMail = true;
    this.exportPayload.isExport = true;
    this.exportPayload.IsReportGenerated = false;
    switch (this.reportTypeIdByList) {
      case 0:
        this.exportPayload['APIToken'] = this.cookieService.get('token');
        this.exportPayload.indicatorId =
          this.exportPayload.indicatorId == '' ? 0 : this.exportPayload.indicatorId;
        this.sendReportMail(this.exportPayload, 'PDFGenerator/CustomReport?reuqestString');
        break;
      case 3:
        this.exportPayload['APIToken'] = this.cookieService.get('token');
        this.exportPayload.indicatorId =
          this.exportPayload.indicatorId == '' ? 0 : this.exportPayload.indicatorId;
        this.sendReportMail(this.exportPayload, 'PDFGenerator/FullReport?reuqestString');
        break;
      case 12: // PIQET Summary report
        this.exportPayload['APIToken'] = this.cookieService.get('token');
        this.exportPayload.indicatorId =
          this.exportPayload.indicatorId == '' ? 0 : this.exportPayload.indicatorId;
        this.sendReportMail(this.exportPayload, 'PDFGenerator/ProductLCAReport?requestString');
        break;
      case 4:
        this.exportPayload['APIToken'] = this.cookieService.get('token');
        this.exportPayload.indicatorId =
          this.exportPayload.indicatorId == '' ? 0 : this.exportPayload.indicatorId;
        this.sendReportMail(this.exportPayload, 'PDFGenerator/CompactReport?requestString');
        break;
      case 11:
        this.exportPayload['APIToken'] = this.cookieService.get('token');
        this.exportPayload.indicatorId =
          this.exportPayload.indicatorId == '' ? 0 : this.exportPayload.indicatorId;
        this.sendReportMail(this.exportPayload, 'PDFGenerator/ISOReport?reuqestString');
        break;
      default:
        break;
    }
  }

  enableAllScenarioDrp() {
    if (this.reportChartForm.controls['baselineScenario'].invalid) {
      this.isShowScenarioNotification = true;
      this.isEnableAllScenarioDrp = true;
    }
  }

  changeBaseScenario(event: { idStr?: string }): void {
    if (!event?.idStr) return;
    this.isShowScenarioNotification = false;
    this.isEnableAllScenarioDrp = false;
    this.selectedBaseScenario = event.idStr;
  }

  eolAction(event: any) {
    this.eolNavService.eolAction(
      event,
      event == 'fill-data-list' ? this.incorrectFilling : this.inValidScenarios, // change when incorrect add
      this.currentProjectId,
      scenario => this.eolNavService.navigateToScenario(scenario, this.currentProjectId, event)
    );
  }

  onSaveFunctionalUnitText() {
    if (this.isCheckISOReport && this.reportChartForm.controls['functionalUnitText'].invalid) {
      return;
    }
    const inputControl = this.reportChartForm.get('functionalUnitText');
    const trimmedValue = inputControl?.value?.trim() || null;

    const payload = {
      projectId: Number(this.currentProjectId),
      functionalUnitText: trimmedValue ? addFullStop(trimmedValue) : null,
    };

    this.reportService.saveFunctionalUnitText(payload).subscribe((res: any) => {
      const msgFn = res.messageType ? this.toaster.error : this.toaster.success;
      msgFn.call(this.toaster, res.message);
    });
  }
  onFunctionalUnitChange(): void {
    const control = this.reportChartForm.get('functionalUnitText');
    this.functionalUnitText = control?.value || '';
  }
  setHoveredIndex(index: number | null): void {
    this.hoveredIndex = index;
  }
}
